import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Baby, Sparkles } from 'lucide-react';

const iaimFaqs = [
  {
    q: 'Kdaj je pravi čas, da začnemo z masažo?',
    a: 'Z masažo dojenčkov lahko pričnete že takoj po rojstvu. Na tečaj ste toplo vabljene vse družine z dojenčki, starimi od 0 do 12 mesecev.',
  },
  {
    q: 'Kako poteka tečaj in koliko časa traja?',
    a: 'Tečaj obsega 5 srečanj, ki se odvijajo enkrat tedensko. Vsako druženje traja približno 60 minut. Redna tedenska srečanja nam omogočajo, da se dojenček navadi na novo okolje, vi pa postopoma in brez pritiska osvojite vse tehnike. Če kakšno srečanje zamudite, ne skrbite – vsebino bomo skupaj nadoknadili po dogovoru.',
  },
  {
    q: 'Kaj pa, če bo moj dojenček med tečajem lačen ali nerazpoložen?',
    a: 'To je pri nas povsem običajno in dobrodošlo. Tečaj v celoti prilagajamo ritmu vašega otroka. Če bo lačen, ga nahranite; če bo utrujen, naj zaspi. V takšnih trenutkih gibe preprosto vadite na lutki, ki jo dobite pri meni, znanje pa nato varno prenesete na dojenčka doma, ko bo pripravljen.',
  },
  {
    q: 'Katere so prednosti masaže za dojenčke?',
    a: '',
    bullets: [
      { label: 'Interakcija (povezovanje)', desc: 'Krepitev zaupanja, očesni stik in dragocen čas, ko se starš in otrok zares začutita.' },
      { label: 'Stimulacija (spodbuda)', desc: 'Blagodejno vpliva na razvoj možganov, prebavo, krvni obtok in zavedanje lastnega telesa.' },
      { label: 'Relaksacija (sprostitev)', desc: 'Manj stresnih hormonov pomeni mirnejšega dojenčka, globlji spanec in manj joka.' },
      { label: 'Olajšanje', desc: 'Masaža dokazano pomaga pri trebušnih krčih (kolikah), bolečinah ob rasti zob in prebavnih težavah.' },
    ],
  },
  {
    q: 'Kako pogosto naj masiram svojega malčka?',
    a: 'Najbolj optimalni rezultati se pokažejo, ko masaža postane vaš vsakodnevni ritual. Ni pomembno, ali traja 5 ali 20 minut – pomembna sta doslednost in vaša prisotnost.',
  },
  {
    q: 'Ali je masaža varna?',
    a: 'Masaža je popolnoma varna, če starši sledite strokovnim navodilom inštruktorice. Na tečaju vas naučim prepoznavati jasne smernice – kdaj je dojenček pripravljen na dotik in v katerih situacijah se masaža ne izvaja. Poleg samih tehnik prejmete tudi natančna navodila, kako pripraviti prostor in okolje, da bo masaža vedno varna, sproščena in ljubeča izkušnja za oba.',
  },
  {
    q: 'Kje se družimo?',
    a: 'Skupinski tečaji trenutno potekajo na dveh lokacijah:',
    bullets: [
      { label: 'Kočevje', desc: 'Center gibanja Rusalka (Reška cesta 15)' },
      { label: 'Ivančna Gorica', desc: 'Terapevtski center Ivančna Gorica (Sokolska ulica 3)' },
    ],
  },
  {
    q: 'Koliko mamic je v skupini?',
    a: 'Da lahko ohranimo intimen in miren prostor, so skupine majhne. Običajno se družimo v krogu do petih družin.',
  },
];

const auriFaqs = [
  {
    q: 'Kdaj jo mamice pogosto izberejo?',
    a: 'Pogosto jo izberejo kot podporo pri:',
    bullets: [
      { label: 'Stresu in notranjemu nemiru', desc: '' },
      { label: 'Utrujenosti in več energije', desc: '' },
      { label: 'Sprememba razpoloženja', desc: '' },
      { label: 'Glavobolih ter napetosti v križu in vratu', desc: '' },
      { label: 'Prebavi in splošnem počutju', desc: '' },
      { label: 'Izzivih, ki spremljajo obdobje dojenja', desc: '' },
    ],
  },
  {
    q: 'Za koga je primerna?',
    a: 'Aurikuloterapija je primerna za vse starostne skupine – od otrok do starejših. Posebej dragocena je tudi za bodoče mamice; pri nosečnicah se jo izvaja po 36. tednu nosečnosti, saj telo odlično podpre in pripravi na lažji porod. Mamicam pa nudi hitro pomoč pri pomirjanju stresa in lažjem soočanju z vsakodnevnimi izzivi starševstva.',
  },
  {
    q: 'Kako poteka namestitev in kaj sledi?',
    a: 'Namestitev je hitra in učinkovita. Najprej uho skrbno očistimo in pripravimo na stimulacijo. Na izbrane ušesne točke nalepimo drobna semenka Vaccaria ali posebne zlate kroglice, ki jih nosite nalepljene do enega tedna, nato jih preprosto odlepite.',
  },
  {
    q: 'Kako hitro so opazni rezultati?',
    a: 'Telo vsakega posameznika je edinstveno, zato so tudi odzivi različni. Hitrost učinka je odvisna od vaše vitalne energije in narave težave. Pri akutnih težavah se olajšanje lahko pojavi že kmalu po namestitvi (v 15 minutah). Za dolgotrajnejše (kronične) izzive pa je običajno potrebnih več zaporednih obravnav.',
  },
  {
    q: 'Ali ima terapija stranske učinke?',
    a: 'Metoda je naravna in varna. Redko se pojavi blaga srbečica pod obližem ali kratka napetost v glavi, kar so le znaki, da se je v telesu aktiviral proces samozdravljenja. Priznava jo Svetovna zdravstvena organizacija (WHO).',
  },
];

const FaqSection = () => {
  const [tab, setTab] = useState('iaim');
  const list = tab === 'iaim' ? iaimFaqs : auriFaqs;

  return (
    <section id="faq" className="py-14 lg:py-20 scroll-mt-20 relative overflow-hidden" data-testid="faq-section">
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-stone-800 font-bold mb-3" data-testid="faq-title">
            Vse, kar te zanima
          </h2>
          <p className="text-stone-600 leading-relaxed max-w-xl mx-auto">
            Preden se nam pridružiš – tukaj so odgovori na najpogostejša vprašanja.
          </p>
        </div>

        {/* Tab switcher */}
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mb-6 p-1.5 bg-white rounded-2xl shadow-sm border border-violet-100 max-w-2xl mx-auto" data-testid="faq-tabs">
          <button
            onClick={() => setTab('iaim')}
            className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-sm font-semibold transition-all ${
              tab === 'iaim'
                ? 'bg-violet-900 text-white shadow-md'
                : 'text-stone-600 hover:bg-violet-50'
            }`}
            data-testid="faq-tab-iaim"
          >
            <Baby size={16} />
            O masaži dojenčka IAIM
          </button>
          <button
            onClick={() => setTab('auri')}
            className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-sm font-semibold transition-all ${
              tab === 'auri'
                ? 'bg-olive-600 text-white shadow-md'
                : 'text-stone-600 hover:bg-olive-100'
            }`}
            data-testid="faq-tab-auri"
          >
            <Sparkles size={16} />
            O aurikuloterapiji
          </button>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {list.map((f, i) => (
            <AccordionItem
              key={`${tab}-${i}`}
              value={`${tab}-${i}`}
              className="border border-violet-100 rounded-xl px-5 bg-white shadow-sm data-[state=open]:shadow-md"
              data-testid={`faq-item-${tab}-${i}`}
            >
              <AccordionTrigger className="hover:no-underline py-4 text-left">
                <span className="font-serif text-lg text-stone-800 font-semibold pr-4">{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-5">
                {f.a && <p className="text-stone-600 text-[15px] leading-relaxed">{f.a}</p>}
                {f.bullets && (
                  <ul className={`${f.a ? 'mt-3' : ''} space-y-2 pl-1`}>
                    {f.bullets.map((b, j) => (
                      <li key={j} className="flex items-start gap-2.5 text-stone-600 text-[15px] leading-relaxed">
                        <span className="flex-shrink-0 mt-2 w-1.5 h-1.5 bg-violet-900 rounded-full" />
                        <span>
                          <span className="font-semibold text-stone-800">{b.label}</span>{b.desc ? <>: {b.desc}</> : ''}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
